var _defs, _rect, _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAnnouncement = function SvgAnnouncement(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{opacity:0.6;}.announcement{fill:#fff;} "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 24,
    height: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "announcement",
    d: "M18,11v2h4V11Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "announcement",
    d: "M16,17.61c.96.71,2.21,1.65,3.2,2.39.4-.53.8-1.07,1.2-1.6-.99-.74-2.24-1.68-3.2-2.4C16.8,16.54,16.4,17.08,16,17.61Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "announcement",
    d: "M20.4,5.6c-.4-.53-.8-1.07-1.2-1.6-.99.74-2.24,1.68-3.2,2.4.4.53.8,1.07,1.2,1.6C18.16,7.28,19.41,6.35,20.4,5.6Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "announcement",
    d: "M4,9a2.006,2.006,0,0,0-2,2v2a2.006,2.006,0,0,0,2,2H5v4H7V15H8l5,3V6L8,9Zm5.03,1.71L11,9.53v4.94L9.03,13.29,8.55,13H4V11H8.55Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "announcement",
    d: "M15.5,12A4.48,4.48,0,0,0,14,8.65v6.69A4.442,4.442,0,0,0,15.5,12Z",
    fill: "#fff"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAnnouncement, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/announcement.a9ba2def.svg";
export { ForwardRef as ReactComponent };